import {
    UPDATE_ACCOUNT_REQUEST,
    UPDATE_ACCOUNT_SUCCESS,
    UPDATE_ACCOUNT_FAILURE,
    REQUEST_CUSTOMER_HISTORY,
    RECEIVE_CUSTOMER_HISTORY, REQUEST_CUSTOMER_DRAFTS, RECEIVE_CUSTOMER_DRAFTS, REMOVE_ACCOUNT_IMAGE
} from '../constants/action_types';
import { updateUser, getCustomerHistory } from '../api/api';
import {isEmpty} from "lodash";
import {generate} from "../../../routing/routes";

const updateAccountRequest = (data) => ({
    type: UPDATE_ACCOUNT_REQUEST,
    data
});

const updateAccountSuccess = (data) => ({
    type: UPDATE_ACCOUNT_SUCCESS,
    data
});

const updateAccountFailure = () => ({
    type: UPDATE_ACCOUNT_FAILURE
});

const requestCustomerHistory = () => ({
    type: REQUEST_CUSTOMER_HISTORY
});

const receiveCustomerHistory = (trips) => ({
    type: RECEIVE_CUSTOMER_HISTORY,
    trips
});

const removeImage= ()=>(dispatch)=>{
    return dispatch({
    type: REMOVE_ACCOUNT_IMAGE
});
    
}


const updateAccount = (data) => (dispatch, getState) => {
    dispatch(updateAccountRequest());
    return updateUser(data)
        .then(res => {
            if (!res.ok || !isEmpty(res.body.errors)) {
                return dispatch(updateAccountFailure());
            } else {
                return dispatch(updateAccountSuccess(res.body.data));
            }
        })
};

const fetchCustomerHistory = () => (dispatch) => {
    dispatch(requestCustomerHistory())

    return getCustomerHistory()
        .then(response => {
            if(response.status === 403){
                throw new Error('Forbidden');
            }
            return response.json()
        })
        .then(json => {
            return dispatch(receiveCustomerHistory(json))
        })
        .catch(error => {
            window.location = generate("login")
        })
}
const fetchDrafts = () => (dispatch) => {
    dispatch({
        type: REQUEST_CUSTOMER_DRAFTS
    })

    return getCustomerHistory({type: 'draft'})
        .then(response => response.json())
        .then(drafts => {
            return dispatch({
                type: RECEIVE_CUSTOMER_DRAFTS,
                drafts
            })
        })
}

export {
    updateAccount,
    fetchCustomerHistory,
    fetchDrafts, 
    removeImage
};
